import { STATUS } from "@/constants/statuses";
import { getLoadingStatus } from "@apps/rewards/utils/statuses";
import { applyTransaction } from "@datorama/akita";
import { catchError, tap } from "rxjs";
import type { Observable } from "rxjs";
import { inject, singleton } from "tsyringe";

import type { LoggerInterface } from "@interfaces/LoggerInterface";

import { rewardsApplicationLoggerToken } from "../../../tokens";
import RewardsFaqApiService from "../api_service/RewardsFaqApiService";
import RewardsFaqStore from "../store/RewardsFaqStore";
import type {
    RewardsFaqListResponseType,
    RewardsFaqQueryParams,
} from "../types";

@singleton()
class RewardsFaqService {
    constructor(
        private readonly rewardsFaqApiService: RewardsFaqApiService,
        private rewardsFaqStore: RewardsFaqStore,
        @inject(rewardsApplicationLoggerToken)
        private readonly logger: LoggerInterface
    ) {}

    public getRewardFaqs(
        queryParams: RewardsFaqQueryParams
    ): Observable<RewardsFaqListResponseType> {
        this.logger.debug("RewardsFaqApiService.getRewardFaqs is started");

        const status = this.rewardsFaqStore.getStatus();
        this.rewardsFaqStore.setStatus(getLoadingStatus(status));

        return this.rewardsFaqApiService.getRewardFaqs(queryParams).pipe(
            catchError((error: unknown) => {
                this.logger.debug(
                    "RewardsFaqApiService.getRewardFaqs is errored",
                    error
                );
                this.rewardsFaqStore.setStatus(STATUS.ERROR);
                throw error;
            }),
            tap((value) => {
                this.logger.debug("RewardFaqApiService.getRewardFaqs is ready");
                //Store Update
                applyTransaction(() => {
                    this.rewardsFaqStore.update((state) => ({
                        ...state,
                        faqList: value.faqs,
                    }));
                    this.rewardsFaqStore.setStatus(STATUS.READY);
                });
            })
        );
    }

    public extractString<T>(value: T): string {
        if (typeof value === "string") return value;

        throw new Error("Expected a string but got a Promise.");
    }
}

export default RewardsFaqService;
